import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconDevTools = t0 => {
  const $ = _c(15);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect width={17} height={16} x={3.5} y={4} rx={2} />;
    t4 = <path d="M3.5 4h17v3h-17z" />;
    t5 = <circle cx={6} cy={5.5} r={0.7} fill="currentColor" />;
    t6 = <circle cx={8.5} cy={5.5} r={0.7} fill="currentColor" />;
    t7 = <circle cx={11} cy={5.5} r={0.7} fill="currentColor" />;
    t8 = <path d="m8.5 11.5-2 2 2 2M15.5 11.5l2 2-2 2" />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t2) {
    t9 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" width={t1} height={t2} {...props}>{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
IconDevTools.displayName = 'IconDevTools';